// API URL 的集合
export const API_URLS = {
    getData: "/ring/storeSelectResult", 
    selectCode: "/ring/selectCode/", 
    deleteOrganizationCode: "/ring/delete/", 
    // 添加其他接口路径
  };
  